module.exports = __webpack_public_path__ + "img/img10.e906882a.png";